import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Parse query params into an object (decodes URI components)
export function parseQueryParams(search) {
  const params = {};
  if (!search) return params;
  const q = search.startsWith('?') ? search.slice(1) : search;
  q.split('&').forEach(pair => {
    const [k, v] = pair.split('=');
    if (!k) return;
    try { params[decodeURIComponent(k)] = v ? decodeURIComponent(v.replace(/\+/g, ' ')) : ''; } catch { params[k] = v || ''; }
  });
  return params;
}
